import { render, staticRenderFns } from "./LinkManagementTicketConfirmation.vue?vue&type=template&id=85b04ed2&scoped=true&"
import script from "./LinkManagementTicketConfirmation.vue?vue&type=script&lang=ts&"
export * from "./LinkManagementTicketConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b04ed2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VForm,VIcon,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85b04ed2')) {
      api.createRecord('85b04ed2', component.options)
    } else {
      api.reload('85b04ed2', component.options)
    }
    module.hot.accept("./LinkManagementTicketConfirmation.vue?vue&type=template&id=85b04ed2&scoped=true&", function () {
      api.rerender('85b04ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/incidents/link-management/components/LinkManagementTicketConfirmation.vue"
export default component.exports